module.exports = __webpack_public_path__ + "static/media/back-arrow-header.fed6d9e0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bus-eireann/back-arrow-header.svg
// module id = 289
// module chunks = 0